import { action } from "typesafe-actions"
import { FormatsMdl } from "../../Modal/formats"
import { Constants } from "./formatTypes";



export function storeFormat(payload: FormatsMdl) {
    
    return action(
        Constants.SET_FORMATFILTER, {
            formats: payload
    })
}
export function storeGeneric(payload: FormatsMdl) { 
    return action(
        Constants.SET_GENERICSFILTER, {
            generics: payload
    })
}
